import React, { useContext,useEffect,useState } from 'react';
import './ProductModalDetails.css';
import { ProductModalContext } from '../../ProductModalContext';
import { ContentTypes } from '../util/ProductModalEnums';
import ReactHtmlParser from 'react-html-parser';
import { withTranslation } from 'react-i18next';
import { ShowProductDetailsClicked } from '../../../../../../utils/Analytics';
import ModalMarker from '../../../../../hotspots/ModalMarker';

const ProductModalDetails = ({ t }) => {
    const { productInfo, fontStyles, detailsActive, contentHeight, setShowSizeGuide } = useContext(ProductModalContext);
    const [detailsShow, setDetailsShow] = useState(false);

    const filterStringEnds = (str) => {
        if (!str) {
            return;
        }
        const len = str.length - 1;
        if (str[len] === ',') {
            return str.substr(0, len) + '' + str.substr(len + 1); 
        }

        return str;
    }

    const details = filterStringEnds(productInfo[ContentTypes.DETAILS_BODY_1]);
    const materials = filterStringEnds(productInfo[ContentTypes.DETAILS_BODY_2]);
    
    const detailsOnClick = () => {
        setDetailsShow(!detailsShow)
    }

    useEffect(() => {
        if(detailsShow) {
            ShowProductDetailsClicked(productInfo.TITLE, productInfo.SKU);
        }
    }, [detailsShow])

    return (
        <div className='product-modal-details-container' style={{ minHeight: `50px`, overflowY: 'auto'}}>
            {details && (
                <>
                    <div onClick={detailsOnClick}  className={detailsShow ? 'product-modal-header showdetails' : 'product-modal-header hidedetails' } style={fontStyles.detailsTitlesFontStyle}>
                        {detailsShow ? <div className="detail-icon">-</div> : <div className="detail-icon">+</div>}
                        <div className="details-title">{t('productDetails')}</div>
                    </div>
                    {detailsShow && <div className='product-modal-content' style={fontStyles.detailsBodyFontStyle}> 
                        { ReactHtmlParser(details) }
                    </div>}
                    
                </>)}
            {materials && (
                <>
                    <div className='product-modal-header' style={fontStyles.detailsTitlesFontStyle}>
                        Materials
                    </div>
                    <div className='product-modal-content' style={fontStyles.detailsBodyFontStyle}>
                        { ReactHtmlParser(materials) }
                    </div>
                </>)}

        </div>
    )
}

export default withTranslation()(ProductModalDetails);